import { useFormikContext } from "formik";
import { useContext, useEffect, useMemo, useState } from "react";
import { FormContext } from "../../context/formContext";
import React from "react";
import Input from "../Input";
import CalendarComponent from "../CalendarComponent";
import CheckBoxComponent from "../CheckBoxComponent";
import DataTableComponent from "../DatatableComponent";
import DropdownComponent from "../DropdownComponent";
import EditorComponent from "../EditorComponent";
import FileUploadComponent from "../FileUploadComponent";
import CaptchaComponent from "../CaptchaComponent";
import { AdvisoryText } from "../../../AdvisoryText";
import SearchSelectComponent from "../SearchSelectComponent";
import ErrorComponent from "../ErrorComponent";
import ButtonComponent from "../ButtonComponent";
import InputTextareaComponent from "../InputTextAreaComponent";
import RadioButtonComponent from "../RadioButtonComponent";
import InputNumberComponent from "../InputNumberComponent";

export default function FieldComponent({
  parentKey,
  elementKey,
  fieldType,
  label,
  parentValues,
  hideExpression,
  warn,
  props,
  expressionProps,
  //disabled,
}: {
  parentKey: string;
  elementKey: string;
  fieldType: string;
  label?: string;
  parentValues: any;
  hideExpression?: (formContext: any, values: any, model: any) => boolean;
  warn?: string;
  props: any;
  expressionProps?: { [key: string]: (formContext: any, values: any, model: any, props: any) => any };
  disabled?: boolean;
}) {
  const { values, setFieldValue } = useFormikContext();
  const context = useContext(FormContext);

  const Input = useMemo(() => {
    return matchedInput(fieldType);
  }, [fieldType]);

  const finalKey = useMemo(() => {
    return [parentKey, elementKey].filter((x) => x !== "" && x != null).join(".");
  }, [parentKey, elementKey]);

  const inputValue = useMemo(() => {
    const value = parentValues[elementKey];
    return value;
  }, [elementKey, parentValues]);

  const [resolvedExpressionProps, setResolvedExpressionProps] = useState<{ [key: string]: any }>({});

  useEffect(() => {
    if (expressionProps != null) {
      const newProps: { [key: string]: any } = {};
      Object.keys(expressionProps).forEach((key) => {
        const res = expressionProps[key](context.formContextStore, values, parentValues, props);
        newProps[key] = res;
      });
      setResolvedExpressionProps(newProps);
    }

    if (hideExpression != null) {
      const isHidden = hideExpression(context.formContextStore, values, parentValues);
      // Only update the state if `isHidden` differs from `hidden`
      if (isHidden !== parentValues[elementKey + "Hidden"]) {
        setFieldValue(finalKey + "Hidden", isHidden);
      }
    }
  }, [expressionProps, hideExpression, values, parentValues, context, props]);

  return (
    <>
      {!parentValues[elementKey + "Hidden"] && (
        <div className="w-full">
          <Input
            name={finalKey}
            value={inputValue}
            warn={warn}
            label={label}
            parentValues={parentValues}
            //leave last to override any other props
            {...{
              disabled: context.formContextStore.disabled,
              ...props,
              ...resolvedExpressionProps,
            }}
          />
        </div>
      )}
    </>
  );
}

function matchedInput(fieldType: string): React.FC<any> {
  switch (fieldType) {
    case "input":
      return Input;

    case "textarea":
      return InputTextareaComponent;

    case "calendar":
      return CalendarComponent;

    case "checkbox":
      return CheckBoxComponent;

    case "datatable":
      return DataTableComponent;

    case "dropdown":
      return DropdownComponent;

    case "radio":
      return RadioButtonComponent;

    case "editor":
      return EditorComponent;

    case "file":
      return FileUploadComponent;

    case "captcha":
      return CaptchaComponent;

    case "advisory":
      return AdvisoryText;

    case "search":
      return SearchSelectComponent;

    case "error":
      return ErrorComponent;

    case "button":
      return ButtonComponent;

    case "number":
      return InputNumberComponent;

    default:
      return function Default() {
        return <></>;
      };
  }
}
